import menuOpen from './menuOpen';
import darkMode from './darkMode';
import infiniteScroll from './infiniteScroll';

menuOpen();
darkMode();
infiniteScroll();
